import { AccountType } from "src/app/services/question.service";

import { Person } from "./person.class";

export class Child extends Person {
  type = AccountType.CHILD;

  school: string;
}
